import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-sperren-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerSperrenAdminEffects {

    BenutzerSperrenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_SPERREN_ADMIN),
        mergeMap((x: ac.PostBenutzerSperrenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerSperrenAdmin(x.benutzerSperrenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerSperrenAdminErfolgreichAction(result, x.benutzerSperrenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerSperrenAdminFehlerAction(error, x.benutzerSperrenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
